import React from "react";
import { Text } from "@/components/Typography";
import { cn } from "@/utils/cn";

interface ProgressBarProps {
  percentage: number;
  showLabel?: boolean;
  showPercentage?: boolean;
  label?: string;
  className?: string;
  trackClassName?: string;
  fillClassName?: string;
  height?: "sm" | "md" | "lg";
  variant?: "default" | "success" | "pab";
}

export const ProgressBar: React.FC<ProgressBarProps> = ({
  percentage,
  showLabel = false,
  showPercentage = false,
  label,
  className,
  trackClassName,
  fillClassName,
  height = "md",
  variant = "default",
}) => {
  const heightClasses = {
    sm: "h-2",
    md: "h-2",
    lg: "h-3",
  };

  const clampedPercentage = Math.min(100, Math.max(0, percentage));

  return (
    <div className={cn("w-full", className)}>
      {showLabel && label && (
        <div className="flex items-center justify-between mb-2">
          <Text className="font-bold text-sm text-text-dark">{label}</Text>
          {showPercentage && (
            <Text className="font-normal text-xs text-text-dark">{clampedPercentage}%</Text>
          )}
        </div>
      )}
      <div
        className={cn(
          "relative w-full rounded-full overflow-hidden",
          variant === "pab" ? "bg-progress-track" : "bg-theme-bg-surface-raised",
          heightClasses[height],
          trackClassName,
        )}
      >
        <div
          className={cn("h-full rounded-full transition-all duration-300", fillClassName)}
          style={{
            width: `${clampedPercentage}%`,
            background: fillClassName
              ? undefined
              : variant === "success"
                ? "var(--color-success-500)"
                : "var(--goals-progress-gradient)",
          }}
        />
      </div>
      {showPercentage && !showLabel && (
        <div className="text-right mt-1">
          <Text className="font-normal text-xs text-theme-text-muted">{clampedPercentage}%</Text>
        </div>
      )}
    </div>
  );
};
